require("../sass/style.scss");

// require("../fonts/fontello/css/fontello.css");
import gsap from 'gsap';
import {DrawSVGPlugin} from "gsap/DrawSVGPlugin";

gsap.registerPlugin(DrawSVGPlugin);

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");

require("./custom/svg-anim.es6");

import 'sticksy';


(function ($) {
    function AnimationLoad() {
        // ----pie chars----//
        if ($('.svg-overview-wrap').length > 0) {
            $("#wrap-right-cover").hover(
                function () {
                    $('.svg-overview-wrap').addClass("right-hover");
                }, function () {
                    $('.svg-overview-wrap').removeClass("right-hover");
                }
            );

            $("#wrap-left-cover").hover(
                function () {
                    $('.svg-overview-wrap').addClass("left-hover");
                }, function () {
                    $('.svg-overview-wrap').removeClass("left-hover");
                }
            );
        }
        if ($('.pie-wrapp').length > 0) {

            const animationTime = 2;

            gsap.set("circle.pie-circle", {
                drawSVG: "-100.1%",
                rotation: -90,
                transformOrigin: "center center"
            });


            $('.pie-wrapp').click(function () {
                let _this = $(this);
                let target = _this.find('.pie-circle');
                let target_text = _this.find('.text-number');
                let target_box = _this.find('.color-block');

                let target_outside_text = _this.find('.outside-text');

                if (!_this.hasClass('progress') && !_this.hasClass('complete')) {

                    gsap.to($(this).find('.click-me-text'), {
                        opacity: 0,
                    });

                    gsap.to([target_outside_text], {
                        opacity: 1,
                        ease: "none",
                        stagger: {
                            amount: 0,
                            from: "end",
                        },
                    });

                    gsap.to([target_text], {
                        opacity: 1,
                        ease: "none",
                        stagger: {
                            amount: animationTime - 0.4,
                            from: "end",

                        },
                    });

                    gsap.fromTo(target_box, {
                        opacity: 0,
                        height: 0,
                    }, {
                        opacity: 1,
                        height: function (index, target, targets) {
                            return $(target).attr('height');
                        },
                        ease: "none",
                        stagger: {
                            amount: animationTime - 0.4,
                            from: "end",
                        },
                    });


                    gsap.to(target, {
                        drawSVG: "0% 0%",
                        ease: "none",
                        duration: animationTime
                    }).then(function () {
                        _this.removeClass('progress');
                        _this.addClass('complete');
                    });
                    _this.addClass('progress');
                }
            });


            $(".pie-text").hover(
                function () {
                    let parent = $(this).parents('.pie-wrapp');
                    if (parent.hasClass('complete')) {
                        let parent_outside_text = parent.find('.outside-text');
                        gsap.set([parent_outside_text], {
                            opacity: 0
                        });

                        let hoverPiePart = $(this).data("pie-part");
                        gsap.set($(`[data-id="${hoverPiePart}"]`), {
                            opacity: 1
                        });
                    }


                },
                function () {
                    let parent = $(this).parents('.pie-wrapp');
                    let hoverPiePart = $(this).data("pie-part");
                    if (parent.hasClass('complete')) {

                        let parent_outside_text = parent.find('.outside-text');
                        gsap.set([parent_outside_text], {
                            opacity: 1
                        });

                        gsap.set($(`[data-id="${hoverPiePart}"]`), {
                            opacity: 0
                        });
                    }

                }
            );

        }
        // end

        //------ Bar chars --------//
        //---------TYPE1-2 --------- //
        if ($('.bar-type-1').length > 0) {
            const animationTime = 2.5;
            gsap.set(".bar-type-1 .bar-line-wrap .line", {
                width: 0
            });

            gsap.set(".bar-type-1 .last-child rect", {
                width: 0
            });

            gsap.set(".bar-type-1 .bar-line-wrap .one-line rect", {
                width: 0
            });

            gsap.set(".bar-type-1 .bar-line-wrap .bar-title", {
                opacity: 0
            });

            $('.bar-type-1').click(function () {

                let _this = $(this);
                let target_svg = _this.find('.bar-svg');
                let svg_line = _this.find('.bar-line-wrap .line');
                let svg_text = _this.find('.bar-line-wrap .bar-title');


                if (!_this.hasClass('progress') && !_this.hasClass('complete')) {

                    gsap.to(_this.find('.click-me-text'), {
                        opacity: 0,
                    });

                    if (svg_text) {
                        gsap.to([svg_text], {
                            opacity: 1,
                            stagger: function (index, target, list) {
                                let maxStagger = animationTime / list.length + 0.1;
                                return Math.abs(index * maxStagger);
                            },
                        });
                    }

                    if (svg_line.length > 0) {

                        gsap.to([svg_line], {
                            width: function (index, target, targets) {
                                return $(target).attr('width');
                            },
                            stagger: function (index, target, list) {
                                let textId = $(target).data('show-text');
                                let maxStagger = animationTime / list.length + 0.1;
                                gsap.to($('#' + textId + ''), {
                                    opacity: 1,
                                    delay: Math.abs(index * maxStagger)
                                });


                                return Math.abs(index * maxStagger);
                            },
                        }).then(function () {
                            _this.removeClass('progress');
                            if (_this.find('.last-child')) {

                                gsap.to(_this.find('.bar-title2'), {
                                    opacity: 1,
                                });

                                gsap.to(_this.find('.last-child rect'), {
                                    width: function (index, target, targets) {
                                        return $(target).attr('width');
                                    },
                                    onComplete: function () {

                                        let textId = $(this._targets[0]).data('show-text');
                                        gsap.to($('#' + textId + ''), {
                                            opacity: 1,
                                        });
                                    }
                                });
                            }
                            _this.addClass('complete');
                        });
                        _this.addClass('progress');
                    } else {
                        let svg_double_line = _this.find('.bar-line-wrap .one-line');

                        gsap.to([svg_double_line], {
                            stagger: function (index, target, list) {
                                let textId = $(target).data('show-text');
                                let maxStagger = animationTime / list.length + 0.1;
                                gsap.to($('#' + textId + ''), {
                                    opacity: 1,
                                    delay: Math.abs(index * maxStagger)
                                });

                                gsap.to($(target).find('rect'), {
                                    width: function (index, target, targets) {
                                        return $(target).attr('width');
                                    },
                                    delay: Math.abs(index * maxStagger)
                                });

                                return Math.abs(index * maxStagger);

                            },
                        }).then(function () {
                            _this.removeClass('progress');
                            _this.addClass('complete');
                        });
                        _this.addClass('progress');
                    }


                }
            });

        }
        //---------TYPE3 --------- //
        if ($('.bar-type-3').length > 0) {

            const animationTime = 5;
            gsap.set(".bar-type-3 .bar-line-wrap .line", {
                width: 0,
                opacity: 0,
            });
            gsap.set(".bar-type-3 .bar-line-wrap .line-pecent-text", {
                opacity: 0
            });
            gsap.set(".info-block .line", {
                width: 0,
                opacity: 0,
            });
            $('.bar-type-3 ').click(function () {

                let _this = $(this);
                let target_svg = _this.find('.bar-svg');

                gsap.to(_this.find('.click-me-text'), {
                    opacity: 0,
                });

                if (!_this.hasClass('progress') && !_this.hasClass('complete')) {

                    var allBarsTimeline = gsap.timeline({
                        onStart: function () {
                            _this.addClass('progress');
                        },
                        onComplete: function () {
                            _this.removeClass('progress');
                            _this.addClass('complete');
                        }
                    });

                    for (let i = 0; i < target_svg.find('.info-block').length; i++) {

                        allBarsTimeline.to(target_svg.find(".bar-line-wrap .line" + (i + 1) + ""), {
                            width: function (index, target, targets) {
                                return $(target).attr('width');
                            },
                            opacity: 1,
                            duration: animationTime / target_svg.find('.info-block').length,
                        });

                        target_svg.find(".bar-line-wrap .line" + (i + 1) + "").each(function (e) {
                            var text_id = $(this).data('show-text');
                            gsap.to($('#' + text_id + ''), {
                                opacity: 1,
                                delay: animationTime / target_svg.find('.info-block').length * i + 0.5,

                            });
                        });

                        gsap.to(_this.find('.info-block .line-block' + (i + 1) + ''), {
                            width: function (index, target, targets) {
                                return $(target).attr('width');
                            },
                            opacity: 1,
                            delay: animationTime / target_svg.find('.info-block').length * i,
                            duration: animationTime / target_svg.find('.info-block').length
                        });

                    }

                }

            });


        }
        // end

        // Vertical graph
        if ($('.vertical-graph').length > 0) {

            const animationTime = 1;
            gsap.set('.vertical-line rect', {
                height: 0
            });
            gsap.set('.vertical-line .text', {
                opacity: 0
            })

            $('.vertical-graph').on('click', function () {
                let _this = $(this);
                const clickMeText = _this.find('.click-me-text');

                if (!_this.hasClass('progress') && !_this.hasClass('complete')) {

                    const lines = _this.find('.vertical-line');

                    lines.each(function (index, value) {
                        const rect = $(this).find('rect');
                        const rectHeight = $(this).find('rect').attr('height');
                        const text = _this.find('.text');
                        gsap.timeline({
                            onStart: function () {
                                _this.addClass('progress');
                            },
                            onComplete: function () {
                                _this.removeClass('progress');
                                _this.addClass('complete');
                            }
                        })
                            .to(clickMeText, {
                                opacity: 0
                            })
                            .to(rect, {
                                height: rectHeight,
                                duration: animationTime
                            }, '>-0.5')
                            .to(text, {
                                opacity: 1
                            })
                    })

                }
            })
        }
        //end

        //------ Chess chars --------//
        if ($('.chess-wrap').length > 0) {
            const animationTime = 0.9;

            gsap.set(".chess-wrap rect", {
                opacity: 0
            });

            gsap.set(".chess-wrap text:not(.chess-title):not(.click-me-text)", {
                opacity: 0
            });


            $('.chess-wrap').click(function () {
                let _this = $(this);
                let target_svg = _this.find('.chess-svg');
                if (!_this.hasClass('progress') && !_this.hasClass('complete')) {

                    gsap.to(_this.find('.click-me-text'), {
                        opacity: 0,
                    });

                    var allChessTimeline = gsap.timeline({
                        onStart: function () {
                            _this.addClass('progress');
                        },
                        onComplete: function () {
                            _this.removeClass('progress');
                            _this.addClass('complete');
                        }
                    });

                    allChessTimeline.to(_this.find('text:not(.chess-title):not(.click-me-text)'), {
                        opacity: 1,
                        duration: animationTime,
                    });

                    allChessTimeline.to(_this.find('rect'), {
                        opacity: function (e, x) {
                            let opacity = '';
                            if ($(x).attr('fill-opacity')) {
                                opacity = $(x).attr('fill-opacity');
                            } else {
                                opacity = $(x).attr('opacity')
                            }
                            return opacity;
                        },
                        duration: animationTime,
                    });


                }

            })


        }
        //end
        //------ portfolio chars --------//
        if ($('.portfolio-svg-wrap').length > 0) {

            const AnimTime = 0.8;
            var PortfolioTL = gsap.timeline({
                paused: true,
                onStart: function () {
                    $('.portfolio-svg-wrap svg').addClass('progress');
                },
                onReverseComplete: function () {
                    $('.portfolio-svg-wrap svg').removeClass('progress');
                },
                onComplete: function () {
                    $('.portfolio-svg-wrap svg').removeClass('progress');

                }
            });

            PortfolioTL.to(".portfolio-svg .circle-triger", {
                cx: 400,
                duration: AnimTime / 2
            })

                .to(".current-text1", {
                    opacity: 0,
                    duration: AnimTime / 4
                }, '<')
                .to(".current-text2", {
                    opacity: 1,
                    duration: AnimTime / 4
                })
                .to('#belonging23 circle', {
                    r: 63,
                    duration: AnimTime
                }, '-=100%')
                .to('#reliable11 circle', {
                    r: 58,
                    duration: AnimTime
                }, '-=100%')
                .to('#lifelong26 circle', {
                    r: 85,
                    duration: AnimTime
                }, '-=100%')
                .to('#Meaningful22 circle', {
                    r: 120,
                    duration: AnimTime
                }, '-=100%')
                .to('#Humane24 circle', {
                    r: 144,
                    duration: AnimTime
                }, '-=100%')
                .to('#Thriving19 circle', {
                    r: 54,
                    duration: AnimTime
                }, '-=100%')
                .to('#Basic18 circle', {
                    r: 80,
                    duration: AnimTime
                }, '-=100%')
                .to('#Unemployment25 circle', {
                    r: 72,
                    duration: AnimTime
                }, '-=100%')
                .to('#Homeless26 circle', {
                    r: 88,
                    duration: AnimTime
                }, '-=100%')
                .to('#Acute18 circle', {
                    r: 61,
                    duration: AnimTime
                }, '-=100%')
                .to('#Addiction13 circle', {
                    r: 81,
                    duration: AnimTime
                }, '-=100%')
                .to('#Environmental10 circle', {
                    r: 19,
                    duration: AnimTime
                }, '-=100%')
                .to('#Crime6 circle', {
                    r: 38,
                    duration: AnimTime
                }, '-=100%')
                .to('#Lifelong26 circle', {
                    r: 85,
                    duration: AnimTime
                }, '-=100%')


            $('.toggle-status').click(function () {
                if (!$('.portfolio-svg-wrap svg').hasClass('progress')) {
                    ChangeTime();
                    clearInterval(timerId);
                }
            });

            var timerId = setInterval(() => ChangeTime(), 2000);

            function ChangeTime() {
                if (PortfolioTL.paused()) {

                    PortfolioTL.resume()
                } else {
                    PortfolioTL.reversed(!PortfolioTL.reversed())
                    if (PortfolioTL.reversed()) {
                        $('.portfolio-svg-wrap svg').addClass('progress');
                    }
                }


            }


        }


        //
        if ($('.multi-graph').length > 0) {
            const animationTime = 1;

            $('.multi-graph').on('click', function () {
                let _this = $(this);
                const clickMeText = _this.find('.click-me-text');

                if (!_this.hasClass('progress') && !_this.hasClass('complete')) {

                    const wrapps = _this.find('.multi-wrapp');

                    wrapps.each(function (index, value) {
                        const dot = $(this).find('.multi-dot');
                        const dotRadius = dot.attr('r');
                        const lines = $(this).find('.multi-lines');
                        const line = $(this).find('.multi-line');

                        gsap.timeline({
                            onStart: function () {
                                _this.addClass('progress');
                            },
                            onComplete: function () {
                                _this.removeClass('progress');
                                _this.addClass('complete');
                            }
                        })
                            .to(clickMeText, {
                                opacity: 0
                            })
                            .to(dot, {
                                r: dotRadius,
                                duration: animationTime
                            }, '>-0.5')
                            .to(lines, {
                                opacity: 1,
                                duration: animationTime
                            }, '>-0.2')
                            .from(line, {
                                strokeWidth: 1,
                                duration: animationTime
                            })


                    })

                }

                $('.multi-dot').hover(function () {
                    const thisLines = $(this).siblings('.multi-lines');
                    const otherLines = $(this).parent().siblings().find('.multi-lines');

                    gsap.timeline()
                        .to(otherLines, {
                            opacity: 0.1
                        })
                        .to(thisLines, {
                            opacity: 1
                        })
                }, function () {
                    const allLines = _this.find('.multi-lines');

                    gsap.to(allLines, {
                        opacity: 1
                    })
                })
            })
        }
    }

    window.addEventListener("load", AnimationLoad());

    // var stickyEl = new Sticksy('header .container', {
    //     topSpacing: 0, // Specify this when you have a fixed top panel
    //     listen: true, // Listen for the DOM changes in the container
    // });
    //
    // $(window).resize(function () {
    //     if ($(this).width() < 992) {
    //         Sticksy.disableAll();
    //     } else {
    //         Sticksy.enableAll();
    //     }
    // });


    if ($('.title-top h1').length > 0) {
        var stickyTitleTop = $('.title-top').offset().top;

        $(window).scroll(function () {
            if ($(window).scrollTop() > stickyTitleTop) {
                $('.title-top').addClass('fixed');
                $('#content').css('padding-top', $('.title-top').outerHeight());

            } else {
                $('.title-top').removeClass('fixed');
                $('#content').css('padding-top', 0);
            }
        });
    }


    $(document).on("click", "#menu-main a , .nav-arrow a", function (e) {
        e.preventDefault();
        var target = $(this).attr('href');
        var title = $(this).text();

        if (target.indexOf("#") == -1 && window.location.href != target) {

            $.ajax({
                url: target,
                dataType: "html",
                success: function (data) {
                    var nextURL = target;
                    var nextTitle = title;
                    var nextState = {additionalInformation: 'Updated the URL with JS'};

                    window.history.replaceState(nextState, nextTitle, nextURL);
                    document.title = nextTitle;
                    $('#content').html($(data).find('#content').html());
                    $('footer').html($(data).find('footer').html());

                    $('html,body').animate({
                        scrollTop: 0
                    }, 800);


                    $('.sub-menu').collapse('hide');
                    $('.menu-item').removeClass('current-menu-item');

                    $('a[href="' + target + '"]').parents('.menu-item').addClass('current-menu-item');
                    $('a[href="' + target + '"]').parents('.menu-item').find('.sub-menu').collapse('show');

                    if ($(window).width() < 992) {
                        $('header').removeClass('menu-open');
                        $('.menu-trigger').removeClass('open');
                    } else {

                    }
                    if ($('.title-top h1').length > 0) {

                        var stickyTitleTop = $('.title-top').offset().top;
                        $(window).scroll(function () {
                            if ($(window).scrollTop() > stickyTitleTop) {
                                $('.title-top').addClass('fixed');
                                $('#content').css('padding-top', $('.title-top').outerHeight());

                            } else {
                                $('.title-top').removeClass('fixed');
                                $('#content').css('padding-top', 0);
                            }
                        });
                    }

                    AnimationLoad();
                    $('body').removeClass('modal-open');

                }
            });

        }
    });


    $("a[href*='#']:not([href='#'])").click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {

                if ($('.title-top').hasClass('fixed')) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 120
                    }, 800);
                    return false;
                } else {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 163 //+43  - difference
                    }, 800);
                    return false;
                }

            }
        }
    });


    $('.sub-menu').addClass('collapse');
    $('.sub-menu').collapse('hide');

    $('.current-menu-item .sub-menu').collapse('show');

    $('.menu-trigger').click(function () {
        $('header').toggleClass('menu-open');
        $(this).toggleClass('open');
        $('body').toggleClass('modal-open');
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/entry.es6